"use client";

import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import type { Technique } from "@/lib/courses";

interface AttackTechniqueListProps {
  techniques: Technique[];
}

export function AttackTechniqueList({ techniques }: AttackTechniqueListProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-cb-border rounded-xl border border-cb-border overflow-hidden">
      {techniques.map((technique, i) => (
        <div key={i} className="bg-cb-surface">
          <button
            className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-cb-surface-2 transition-colors group"
            onClick={() => setOpen(open === i ? null : i)}
          >
            <div className="flex items-center gap-3 min-w-0">
              <span className="text-xs font-mono text-cb-muted-2 w-6 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-sm font-medium text-cb-text group-hover:text-white transition-colors truncate">
                {technique.name}
              </span>
            </div>
            {open === i ? (
              <ChevronDown className="h-4 w-4 text-cb-muted-2 shrink-0" />
            ) : (
              <ChevronRight className="h-4 w-4 text-cb-muted-2 shrink-0" />
            )}
          </button>
          {open === i && (
            <div className="px-5 pb-4 pl-14 text-sm text-cb-muted leading-relaxed">
              {technique.description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
